import { withOpeningAndClosingBows } from './ceremony'
import type { KataDefinition } from './types'

/**
 * Itsutsu-no-Kata — five forms as a flat list (no category selector).
 * Labels are display numbering only; do not invent descriptive movement names.
 */
export const itsutsuNoKata: KataDefinition = withOpeningAndClosingBows({
  id: 'itsutsu-no-kata',
  name: 'Itsutsu-no-Kata',
  nameJa: '五の形',
  theme: {
    from: '#f9a8d4',
    to: '#a78bfa',
    text: '#4c1d95',
  },
  groups: [
    {
      id: 'forms',
      name: 'Forms',
      techniques: [
        { id: 'itsutsu-form-1', name: 'Form 1', nameJa: '一本目' },
        { id: 'itsutsu-form-2', name: 'Form 2', nameJa: '二本目' },
        { id: 'itsutsu-form-3', name: 'Form 3', nameJa: '三本目' },
        { id: 'itsutsu-form-4', name: 'Form 4', nameJa: '四本目' },
        { id: 'itsutsu-form-5', name: 'Form 5', nameJa: '五本目' },
      ],
    },
  ],
})
